import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

const Contact = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCustomCity, setShowCustomCity] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    // Wenn eigene Stadt eingegeben wurde, übernehme sie als location
    if (data.location === 'custom') {
      data.location = data.customCity;
    }

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setIsSubmitted(true);
        reset();
        setShowCustomCity(false);
      } else {
        throw new Error('Fehler beim Senden der Nachricht');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Es gab einen Fehler beim Senden Ihrer Nachricht. Bitte versuchen Sie es erneut.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const germanCities = [
    'Heilbronn', 'Karlsruhe', 'Stuttgart', 'Mannheim', 'Würzburg', 'Esslingen am Neckar'
  ];

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="card">
            <div className="w-16 h-16 bg-secondary-light rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-secondary mb-4">Vielen Dank!</h2>
            <p className="text-gray-600 mb-6">
              Wir haben Ihre Anfrage erhalten und melden uns in Kürze bei Ihnen.
            </p>
            <button onClick={() => setIsSubmitted(false)} className="btn-primary">
              Neue Anfrage stellen
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
       {/* Hero Section */}
      <section className="bg-gradient-to-br from-secondary to-primary text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Kontakt & Angebot anfragen</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Lassen Sie uns gemeinsam Ihre WEG-Verwaltung modernisieren. 
            Füllen Sie das Formular aus und wir erstellen Ihnen ein maßgeschneidertes Angebot.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          
            <div>
              <h2 className="text-3xl font-bold text-secondary mb-6">Unverbindliches Angebot anfragen</h2>
              <p className="text-gray-600 mb-8">
                Wir stehen Ihnen gerne zur Verfügung, um Ihre Fragen zu beantworten.
              </p>
            </div>
 {/* Contact Form Section */}
              <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
                {/* Honeypot-Feld: unsichtbar für echte Nutzer */}
                <div style={{ display: 'none' }}>
                  <label htmlFor="website">Website</label>
                  <input
                    type="text"
                    id="website"
                    autoComplete="off"
                    tabIndex="-1"
                    {...register('website')}
                  />
                </div>
                {/* Lage */}
                <div>
                  <label htmlFor="location" className="block text-base font-medium text-gray-700 mb-2">
                    Objektlage *
                  </label>
                  <select
                    id="location"
                    {...register('location', { required: 'Bitte wählen Sie einen Ort aus' })}
                    className="input-field"
                    onChange={(e) => {
                      const selected = e.target.value;
                      setShowCustomCity(selected === 'custom');
                    }}
                  >
                    <option value="">Bitte wählen Sie einen Ort aus</option>
                    {germanCities.map((city) => (
                      <option key={city} value={city}>{city}</option>
                    ))}
                    <option value="custom">Mein Ort ist nicht dabei</option>
                  </select>
                  {errors.location && (
                    <p className="mt-1 text-sm text-alert">{errors.location.message}</p>
                  )}
                </div>

                {showCustomCity && (
                  <div>
                    <label htmlFor="customCity" className="block text-base font-medium text-gray-700 mb-2">
                      Bitte geben Sie Ihren Ort ein *
                    </label>
                    <input
                      type="text"
                      id="customCity"
                      {...register('customCity', {
                        required: 'Bitte geben Sie einen Stadtnamen ein',
                        minLength: { value: 2, message: 'Mindestens 2 Zeichen erforderlich' }
                      })}
                      className="input-field"
                      placeholder="z.B. Beispielstadt"
                    />
                    {errors.customCity && (
                      <p className="mt-1 text-sm text-alert">{errors.customCity.message}</p>
                    )}
                  </div>
                )}

                {/* Baujahr */}
                <div>
                  <label htmlFor="constructionYear" className="block text-base font-medium text-gray-700 mb-2">
                    Baujahr des Objekts *
                  </label>
                  <input
                    type="number"
                    id="constructionYear"
                    min="1800"
                    max={new Date().getFullYear()}
                    {...register('constructionYear', {
                      required: 'Bitte geben Sie das Baujahr an',
                      min: { value: 1800, message: 'Baujahr muss nach 1800 liegen' },
                      max: { value: 2100, message: 'Baujahr kann nicht so weit in der Zukunft liegen' }
                    })}
                    className="input-field"
                    placeholder="z.B. 1995"
                  />
                  {errors.constructionYear && (
                    <p className="mt-1 text-sm text-alert">{errors.constructionYear.message}</p>
                  )}
                </div>

                {/* Checkboxen */}
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <input
                      type="checkbox"
                      id="renovation"
                      {...register('renovation')}
                      className="mt-1 w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                    />
                    <label htmlFor="renovation" className="text-base text-gray-700">
                      Es ist mindestens eine Sanierung geplant
                    </label>
                  </div>

                  <div className="flex items-start space-x-3">
                    <input
                      type="checkbox"
                      id="legalDisputes"
                      {...register('legalDisputes')}
                      className="mt-1 w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                    />
                    <label htmlFor="legalDisputes" className="text-base text-gray-700">
                      Es bestehen aktuell rechtliche Auseinandersetzungen (z.B. innerhalb der WEG oder auch mit Dritten)
                    </label>
                  </div>
                </div>

                {/* Objektgröße */}
                <div>
                  <label htmlFor="objectSize" className="block text-base font-medium text-gray-700 mb-2">
                    Objektgröße (Anzahl der Einheiten) *
                  </label>
                  <input
                    type="number"
                    id="objectSize"
                    min="1"
                    {...register('objectSize', {
                      required: 'Bitte geben Sie die Anzahl der Einheiten an',
                      min: { value: 1, message: 'Mindestens 1 Einheit erforderlich' }
                    })}
                    className="input-field"
                    placeholder="z.B. 12"
                  />
                  {errors.objectSize && (
                    <p className="mt-1 text-sm text-alert">{errors.objectSize.message}</p>
                  )}
                </div>

                {/* E-Mail */}
                <div>
                  <label htmlFor="email" className="block text-base font-medium text-gray-700 mb-2">
                    Die E-Mail-Adresse, unter der wir Sie erreichen können *
                  </label>
                  <input
                    type="email"
                    id="email"
                    {...register('email', {
                      required: 'Bitte geben Sie Ihre E-Mail-Adresse an',
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
                      }
                    })}
                    className="input-field"
                    placeholder="ihre.email@beispiel.de"
                  />
                  {errors.email && (
                    <p className="mt-1 text-sm text-alert">{errors.email.message}</p>
                  )}
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'Wird gesendet...' : 'Angebot anfragen'}
                </button>
              </form>
            
          
        </div>
      </section>

      {/* Preisgestaltung Section */}
      <section className="py-20 bg-background-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-4">
              Unsere Preisgestaltung – fair und speziell für kleine WEGs
            </h2>
          </div>

          <div className="max-w-4xl mx-auto space-y-8 text-gray-700">
            <p className="text-base leading-relaxed">
              Die Anforderungen an die WEG-Verwaltung steigen kontinuierlich: mehr gesetzliche Pflichten, höhere Dokumentationsanforderungen, zunehmende Komplexität und ein spürbarer Fachkräftemangel. Das <strong>VDIV-Branchenbarometer 2025</strong> zeigt klar, wie die Branche darauf reagiert: Wirtschaftlichkeit geht vor Wachstum, Mindestgrößen werden definiert und Vergütungen deutlich angehoben.
            </p>

            <p className="text-base leading-relaxed">
              Ein zentraler Fakt: <strong>Die durchschnittlichen Verwaltungskosten pro Einheit sind 2024 auf 28,35 € pro Monat gestiegen.</strong> Gleichzeitig lehnen <strong>rund 42 % der größeren Hausverwaltungen WEGs mit weniger als 18 Wohneinheiten pauschal ab</strong>. Der Grund ist nüchtern: Bei klassischer Arbeitsweise fällt <strong>nahezu derselbe Verwaltungsaufwand an</strong>, wirtschaftlich bleibt bei kleinen Gemeinschaften jedoch zu wenig übrig.
            </p>

            <p className="text-base leading-relaxed">
              Genau hier setzt die <strong>magicOtter GbR</strong> bewusst anders an.
            </p>

            <div className="pt-6">
              <h3 className="text-xl md:text-2xl font-semibold text-secondary mb-4">
                Bezahlbare Verwaltung ab 17,50 € pro Einheit und Monat
              </h3>

              <p className="text-base leading-relaxed mb-4">
                Wir verwalten kleine Wohnungseigentümergemeinschaften <strong>bereits ab 17,50 € pro Einheit und Monat</strong>. Möglich wird das nicht durch Sparen an der Qualität, sondern durch einen strukturell anderen Ansatz: <strong>Digitalisierung, Standardisierung und klar definierte Prozesse</strong>.
              </p>

              <p className="text-base leading-relaxed mb-3">
                Das bedeutet für Sie:
              </p>

              <ul className="space-y-2 mb-6 ml-6">
                <li className="flex items-start">
                  <span className="text-secondary mr-2">•</span>
                  <span>wirtschaftlich tragfähige Preise auch für kleine WEGs</span>
                </li>
                <li className="flex items-start">
                  <span className="text-secondary mr-2">•</span>
                  <span>keine Abstriche bei Ordnung, Transparenz oder Rechtssicherheit</span>
                </li>
                <li className="flex items-start">
                  <span className="text-secondary mr-2">•</span>
                  <span>persönliche Betreuung statt anonymer Massenverwaltung</span>
                </li>
              </ul>
            </div>

            <div className="pt-6">
              <h3 className="text-xl md:text-2xl font-semibold text-secondary mb-4">
                Unsere Preislogik
              </h3>

              <p className="text-base leading-relaxed mb-3">
                Unsere Vergütung richtet sich nicht nach pauschalen Marktpreisen, sondern nach objektiven Faktoren:
              </p>

              <ul className="space-y-2 mb-6 ml-6">
                <li className="flex items-start">
                  <span className="text-secondary mr-2">•</span>
                  <span>Größe und Struktur der Gemeinschaft</span>
                </li>
                <li className="flex items-start">
                  <span className="text-secondary mr-2">•</span>
                  <span>tatsächlicher Verwaltungsaufwand (z. B. Sanierungen, Sonderthemen)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-secondary mr-2">•</span>
                  <span>digitaler Reifegrad der WEG</span>
                </li>
              </ul>

              <p className="text-base leading-relaxed">
                Kleine Gemeinschaften sind wirtschaftlich verwaltbar, <strong>wenn Prozesse konsequent effizient organisiert sind</strong>. Automatisierung reduziert manuelle Arbeit – der Effizienzgewinn kommt direkt den Eigentümern zugute.
              </p>
            </div>

            <div className="pt-6">
              <h3 className="text-xl md:text-2xl font-semibold text-secondary mb-4">
                Transparent statt quersubventioniert
              </h3>

              <p className="text-base leading-relaxed">
                Wir verzichten bewusst auf Quersubventionierung zwischen einfachen und aufwendigen Objekten. Jede Gemeinschaft zahlt einen fairen, nachvollziehbaren Preis. Sonderleistungen werden klar ausgewiesen und nur dann berechnet, wenn sie tatsächlich anfallen.
              </p>
            </div>

            <div className="pt-6">
              <h3 className="text-xl md:text-2xl font-semibold text-secondary mb-4">
                Unser Anspruch
              </h3>

              <p className="text-base leading-relaxed mb-3">
                Eine angemessene Vergütung ist kein Selbstzweck. Sie ist die Grundlage für:
              </p>

              <ul className="space-y-2 mb-6 ml-6">
                <li className="flex items-start">
                  <span className="text-secondary mr-2">•</span>
                  <span>verlässliche Erreichbarkeit</span>
                </li>
                <li className="flex items-start">
                  <span className="text-secondary mr-2">•</span>
                  <span>rechtssichere Verwaltung nach aktueller Gesetzeslage</span>
                </li>
                <li className="flex items-start">
                  <span className="text-secondary mr-2">•</span>
                  <span>stabile Prozesse und langfristige Betreuung</span>
                </li>
              </ul>

              <p className="text-base leading-relaxed">
                So ermöglichen wir kleinen WEGs professionelle Verwaltung dort, wo andere längst absagen – <strong>wirtschaftlich sinnvoll, persönlich und zukunftsfähig</strong>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
